// import React from 'react'
// import styled from 'styled-components'
// import { motion } from 'framer-motion';
// import Me from '../assets/Images/Dark_me-removebg-preview.png';

// const Box = styled(motion.div)`
// position: absolute;
// left: 50%;
// top: 50%;
// transform: translate(-50%,-50%);

// width: 65vw;
// height: 55vh;
// display: flex;


// background: linear-gradient(
//     to right,
//     ${props => props.theme.body} 50%,
//     ${props => props.theme.text} 50%) bottom,
//     linear-gradient(
//     to right,
//     ${props => props.theme.body} 50%,
//     ${props => props.theme.text} 50%) top;

//     background-repeat: no-repeat;
//     background-size: 100% 2px;
//     border-left: 2px solid ${props => props.theme.body};
//     border-right: 2px solid ${props => props.theme.text};

//     z-index: 1;

// );
// `

// const SubBox = styled.div`
// width: 50%;
// position: relative;
// display: flex;

// .pic{
//     position: absolute;
//     bottom: 0;
//     left: 50%;
//     transform: translate(-50%, 0%);
//     width: 100%;
//     height: auto;
// }
// `

// const Text = styled.div`
// font-size: calc(1em + 1.5vw);
// color: ${props => props.theme.body};
// padding: 2rem;
// cursor: pointer;

// display: flex;
// flex-direction: column;
// justify-content: space-evenly;

// &>*:last-child{
//     color: ${props => `rgba(${props.theme.bodyRgba}, 0.6)`};
//     font-size: calc(0.5rem + 1.5vw);
//     font-weight: 300;
// }

// `

// const Intro = () => {
//   return (
//     <Box
//     initial={{height:0}}
//     animate={{height:'55vh'}}
//     transition={{type:"spring", duration: 2, delay: 1}}
//     >
//         <SubBox>
//             <Text>
//                 <h1>Hi,</h1>
//                 <h3>I'm Edward.</h3>
//                 <h6>I Build simple yet stunning Fullstack Web/Desktop Applications.</h6>

//             </Text>
//         </SubBox>
//         <SubBox>
//             <motion.div
//              initial={{opacity:0}}
//              animate={{opacity:1}}
//              transition={{duration: 1, delay: 2}}
//             >
//                 <img className='pic' src={Me} alt='Profile-image'/>
//             </motion.div>
//         </SubBox>
//     </Box>
//   )
// }

// export default Intro







import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion';
import Me from '../assets/Images/IMG_7336-removebg-preview.png';
// import Me from '../assets/Images/Dark_me-removebg-preview.png';

const Box = styled(motion.div)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 65vw;
  height: 55vh;
  display: flex;

  background: linear-gradient(
      to right,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%) bottom,
    linear-gradient(
      to right,
      ${props => props.theme.body} 50%,
      ${props => props.theme.text} 50%) top;
  
  background-repeat: no-repeat;
  background-size: 100% 2px;
  border-left: 2px solid ${props => props.theme.body};
  border-right: 2px solid ${props => props.theme.text};
  z-index: 1;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 90vw;
    height: 100vh; /* Take full screen height */
    background: linear-gradient(
      to bottom,
      ${props => props.theme.text} 50%,
      ${props => props.theme.body} 50%);

    
    border-left: none;
    border-right: none;
    border-top: 2px solid ${props => props.theme.body};
    // border-bottom: 2px solid ${props => props.theme.text};
  }
`;

const SubBox = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100%;
    height: 50%; /* Each section takes half the screen */
     
    // border-left: 2px solid ${props => props.theme.body};
    // border-right: 2px solid ${props => props.theme.text};
  }
`;

const Text = styled.div`
  font-size: calc(1em + 1.5vw);
  color: ${props => props.theme.body};
  padding: 2rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  & > *:last-child {
    color: ${props => `rgba(${props.theme.bodyRgba}, 0.6)`};
    font-size: calc(0.5rem + 1.5vw);
    font-weight: 300;
  }

  @media (max-width: 768px) {
    color: ${props => props.theme.body}; /* Text color switches on mobile */
    padding: 2rem;
  

  }
`;

const ImageContainer = styled(motion.div)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;

  .pic {
    width: 100%;
    height: 100%;
    object-fit: contain; /* Ensures it fits within the area without distortion */
  }
`;

const Intro = () => {
  return (
    <Box
      initial={{ height: 0 }}
      animate={{ height: '55vh' }}
      transition={{ type: "spring", duration: 2, delay: 1 }}
    >
      <SubBox>
        <Text>
          <h1>Hi,</h1>
          <h3>I'm Edward.</h3>
          <h6>I Build simple yet stunning Web Applications. In my free time, I'm an AI Automations Architect. And sometimes, i'm a researcher. I'm pleased to have you here.</h6>
        </Text>
      </SubBox>
      <SubBox>
        <ImageContainer
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2 }}
        >
          <img className="pic" src={Me} alt=''/>
        </ImageContainer>
      </SubBox>
    </Box>
  );
};

export default Intro;

